// The home page is the bare locale root: "/", "/us", "/se/", etc.
// Used to scope logged-out homepage treatments (hero, banner/ad suppression).
export default function isHomePath(pathname) {
  if (!pathname) return false;
  return /^\/([a-z]{2})?\/?$/i.test(pathname);
}
